import { MainLayout } from "@/layout";
import { contactUsRoute } from "@/config/RouteConfig";

const contactUs = {
  path: "",
  component: MainLayout,
  children: [
    {
      ...contactUsRoute,
      component: () => import("@/views/ContactUs"),
    },
  ],
};

export default contactUs;
